// @flow
import React from 'react';
import { Row, Text, Tooltip, Button } from '@nextui-org/react';
import { User, Logout, Home } from 'react-iconly';
import { OpenMenu } from '../icons/OpenMenu';
import { CloseMenu } from '../icons/CloseMenu';

const TopMenu = ({ onLogOut }) => {
  return (
    <div className="w-48 p-2 bg-white rounded-lg shadow-lg">
      <Button 
        auto 
        light 
        className="w-full justify-start hover:bg-gray-100 transition-colors"
        onClick={(e) => {
          e.preventDefault(); 
          window.location.href = '/products/select';
        }}
      >
        <Home fill="currentColor" set="light" />
        <Text size={16} className="ml-3">Home</Text>
      </Button>
      <Button 
        light 
        auto 
        className="w-full justify-start hover:bg-gray-100 transition-colors text-red-600"
        onClick={onLogOut}
      >
        <Logout fill="currentColor" set="light" />
        <Text size={16} className="ml-3">Logout</Text>
      </Button>
    </div>
  );
};

export default function Header({ 
  leftTitle, 
  centerTitle, 
  rightItem, 
  name, 
  isNavOpen, 
  onNavShow, 
  onNavHide, 
  onLogOut 
}) {
  return (
    <Row className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="flex items-center h-16 px-2 w-full">
        {/* Navigation Toggle */}
        <button 
          className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          onClick={isNavOpen ? onNavHide : onNavShow}
          aria-label={isNavOpen ? "Close navigation" : "Open navigation"}
        >
          {isNavOpen ? (
            <CloseMenu width={30} height={30} fill='currentColor'/>
          ) : (
            <OpenMenu width={30} height={30} fill='currentColor'/>
          )}
        </button>

        {/* Left Title */}
        <div className="ml-3">
          {leftTitle}
        </div>

        {/* Center Title */}
        <div className="flex-1 text-center">
          <div className="text-xl font-semibold text-gray-800">
            {centerTitle}
          </div>
        </div>

        {/* Right Item */}
        <div className="mr-4">
          {rightItem}
        </div>

        {/* User Menu */}
        <Tooltip 
          content={<TopMenu onLogOut={onLogOut}/>}
          placement="bottom"
          trigger="click"
          className="bg-white"
        >
          <button className="flex items-center space-x-2 p-2 rounded-lg hover:bg-gray-100 transition-colors">
            <span className="text-gray-700 font-medium">{name}</span>
            <User size="large" set="light" filled className="text-primary" />
          </button>
        </Tooltip>
      </div>
    </Row>
  );
}
